import React from "react";

const AccountGroupTable = ({ accountGroups = [] }) => {
    if (!accountGroups.length) {
        return (
        <div className="workspace-empty">
            <div className="workspace-empty-icon">◌</div>

            <h4>No account groups found</h4>

            <p>Try changing your search or filter.</p>
        </div>
        );
    }

    return (
        <div className="ledger-table-wrapper">
        <table className="ledger-table">
            <thead>
                <tr>
                    <th>Account Group</th>
                    <th>Code</th>
                    <th>Parent</th>
                    <th>Type</th>
                    <th>Ledgers</th>
                    <th>Status</th>
                </tr>
            </thead>

            <tbody>
                {accountGroups.map((group) => (
                    <tr key={group.id}>
                        <td>
                            <div className="ledger-name-cell">
                                <div className="ledger-icon">
                                    {group.name?.charAt(0)?.toUpperCase() || "G"}
                                </div>

                                <div className="ledger-primary">
                                    <strong>{group.name}</strong>

                                    <span>
                                        {group.is_system
                                            ? "System account group"
                                            : "Custom account group"}
                                    </span>
                                </div>
                            </div>
                        </td>

                        <td>
                            <span className="code-value">{group.code}</span>
                        </td>

                        <td>
                            {group.parent_name || <span className="muted">Root group</span>}
                        </td>

                        <td>
                            <span className="ledger-type">{group.group_type || "—"}</span>
                        </td>

                        <td>
                            <strong>{group.ledgerCount || 0}</strong>
                        </td>

                        <td>
                            <span
                                className={
                                    group.is_active !== false
                                    ? "status-pill active"
                                    : "status-pill inactive"
                                }
                            >
                                {group.is_active !== false ? "Active" : "Inactive"}
                            </span>
                        </td>
                    </tr>
                ))}
                </tbody>
            </table>
        </div>
    );
};

export default AccountGroupTable;
